var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { to } from "@lib/utils";
import { EVM_CHAIN_IDS, Network } from "@models/network";
import { Wallet } from "@models/wallet";
import * as Sentry from "@sentry/browser";
import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";
import { convertUtf8ToHex } from "@walletconnect/utils";
import { utils } from "ethers";
import { signingMessage, WalletError } from "./utils";
export const initWcConnector = (qrcodeModal = true, reset = true) => __awaiter(void 0, void 0, void 0, function* () {
    const connector = new WalletConnect({
        bridge: "https://bridge.walletconnect.org",
        qrcodeModal: qrcodeModal ? QRCodeModal : undefined,
    });
    if (reset)
        yield to(connector.killSession());
    if (!connector.connected) {
        const { err } = yield to(connector.createSession());
        if (err) {
            console.log(err);
            return null;
        }
    }
    // console.log("initWcConnector", connector.uri);
    return connector;
});
const walletConnectHandler = (connector) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (!connector)
                return reject(WalletError.UNKNOWN_ERROR);
            // Subscribe to connection events
            connector.on("connect", (error, payload) => {
                console.log("on_connect", payload);
                if (error) {
                    console.log(error);
                    return reject(WalletError.UNKNOWN_ERROR);
                }
                const [{ accounts, chainId }] = payload.params;
                console.log(accounts, chainId);
                resolve({ account: accounts[0], chainId });
            });
            connector.on("session_update", (error, payload) => {
                console.log("session_update", payload);
                if (error) {
                    console.log(error);
                    return reject(WalletError.UNKNOWN_ERROR);
                }
                const [{ accounts, chainId }] = payload.params;
                console.log(accounts, chainId);
                resolve({ account: accounts[0], chainId });
            });
            connector.on("disconnect", (error, payload) => {
                console.log("disconnect", payload);
                if (error) {
                    console.log(error);
                    return reject(WalletError.UNKNOWN_ERROR);
                }
                reject(WalletError.UNKNOWN_ERROR);
            });
        }
        catch (error) {
            console.log(error);
            reject(WalletError.UNKNOWN_ERROR);
        }
    }));
});
export const connectWalletWCByConnector = (connector) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "connectWalletWCByConnector",
        level: "info",
    });
    if (connector.connected && connector.accounts.length == 1)
        return { walletAddress: connector.accounts[0], connector };
    const { err, res } = yield to(walletConnectHandler(connector));
    if (err || !res)
        throw err || WalletError.UNKNOWN_ERROR;
    const { account, chainId } = res;
    if (!EVM_CHAIN_IDS.includes(chainId))
        throw WalletError.UNSUPPORTED_NETWORK;
    console.log("connectWalletWCByConnector", account, chainId);
    return { walletAddress: account, connector };
});
export const connectWalletWC = () => __awaiter(void 0, void 0, void 0, function* () {
    const connector = yield initWcConnector();
    if (!connector)
        throw WalletError.UNKNOWN_ERROR;
    return connectWalletWCByConnector(connector);
});
export const verifyWalletWC = (connectWalletResponse) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "verifyWalletWC",
        level: "info",
    });
    const connector = connectWalletResponse.connector;
    if (!connector || !connector.connected || connector.accounts.length != 1)
        throw WalletError.UNKNOWN_ERROR;
    const { walletAddress } = connectWalletResponse;
    const message = signingMessage();
    const encodedMessage = convertUtf8ToHex(message);
    const msgParams = [encodedMessage, walletAddress];
    const { err, res: signature } = yield to(connector.signPersonalMessage(msgParams));
    if (err) {
        console.log(err);
        throw WalletError.UNKNOWN_ERROR;
    }
    const address = utils.verifyMessage(message, signature);
    if (address.toLowerCase() != walletAddress.toLowerCase())
        throw WalletError.UNVERIFIED;
    return new Wallet({ network: Network.ETHEREUM, address, verified: true });
});
